import { FormattedMessage, useIntl } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const AtlassianIntelligence = () => {
    const intl = useIntl();

    return (
        <div>
            <h2>
                <FormattedMessage
                    id="ConfluencePricingPage.modalContents.atlassianIntelligence.heading"
                    defaultMessage="Atlassian Intelligence (AI)"
                />
            </h2>
            <p>
                <FormattedMessage
                    id="ConfluencePricingPage.modalContents.atlassianIntelligence.summary"
                    defaultMessage="Communicate efficiently, glean relevant insights, and work on what matters with AI capabilities. {br}{br} These include AI-powered editing experiences, quick summaries of long pages, and more. <a>Learn more.</a>"
                    values={{
                        ...DEFAULT_VALUES,
                        a: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="confluence"
                                data-label-english="Learn more."
                                data-track-event="ConfluencePricingPage.atlassianIntelligence.learnMore"
                                data-event-container="ConfluencePricingPage"
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                href={`https://support.atlassian.com${useLocalizedHref(
                                    "/organization-administration/docs/get-started-with-atlassian-intelligence/"
                                )}`}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
            <div>
                <img
                    src="https://wac-cdn.atlassian.com/misc-assets/webp-images/Confluence_AI.webp"
                    alt={intl.formatMessage({
                        id: "ConfluencePricingPage.features.AtlassianIntelligence.altText",
                        defaultMessage: "Example of a space"
                    })}
                    height={350}
                    loading="lazy"
                />
            </div>
        </div>
    );
};

export default AtlassianIntelligence;
